export const axisGridColor = '#FFFFFF80';

export const ticksColor = '#FFFFFF80';
